import { render, staticRenderFns } from "./openScreenPromotion.vue?vue&type=template&id=f3d21080&"
import script from "./openScreenPromotion.vue?vue&type=script&lang=js&"
export * from "./openScreenPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports